import { useEffect, useState } from "react";
import { Waves } from "lucide-react";

const MICROCOPY = [
  "Reading your Dive Brain…",
  "Connecting your offer to your audience…",
  "Building hooks, captions and campaign angles…",
  "Adding strategic depth…",
  "Cross-checking against the Dive Intelligence Layer…",
  "Finalising your output…",
];

export default function GenerateLoader({ label }) {
  const [phase, setPhase] = useState(0);
  const [pct, setPct] = useState(6);

  useEffect(() => {
    const t = setInterval(() => setPhase((p) => (p + 1) % MICROCOPY.length), 2600);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    // Smooth fake progress: eases towards 92%, never completes on its own.
    const t = setInterval(() => {
      setPct((p) => {
        if (p >= 92) return 92;
        const delta = Math.max(0.4, (92 - p) * 0.03);
        return Math.min(92, +(p + delta).toFixed(1));
      });
    }, 400);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="generate-loader" className="dms-card p-6 sm:p-8 bg-gradient-to-br from-[#F0FDFA] to-white border-[#4FD1C5]/30">
      <div className="flex items-center gap-3 text-[#0A2342]">
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#4FD1C5] opacity-75" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-[#4FD1C5]" />
        </span>
        <Waves className="w-4 h-4 text-[#1D4E89]" />
        <span className="font-heading font-bold text-[15px]">{label || "Building your dive marketing strategy"}</span>
      </div>
      <p className="mt-3 text-[13.5px] text-[#475569]">
        Please be patient. Some outputs can take up to 2 minutes. Do not refresh the page.
      </p>
      <div className="mt-5 h-2 rounded-full bg-[#E2E8F0] overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-[#1D4E89] via-[#4FD1C5] to-[#1D4E89] bg-[length:200%_100%] animate-shimmer transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="mt-3 text-[12.5px] text-[#64748B] italic transition-opacity duration-300" key={phase}>
        {MICROCOPY[phase]}
      </div>
    </div>
  );
}
